<script>
  import { Button } from "../../../Components";
  export let pageName;
  export let hasData;
  export let badge = false;
  export let tooltip = false;
  export let showPage;
  export let headline;
  export let description;
  export let viewBox = "0 0 640 640";

  const missingDataText = "Klicken Sie hier, um Ihre Daten zu vervollständigen";
</script>

<Button
  on:click={() => {
    showPage(pageName);
  }}
  ghost
  badge={hasData[pageName] ? badge : "warning"}
  tooltip={hasData[pageName] ? tooltip : missingDataText}
  class="h-28"
>
  <span class="flex flex-1 items-center gap-2">
    <svg xmlns="http://www.w3.org/2000/svg" {viewBox} class="h-12 w-12 fill-current">
      <slot />
    </svg>

    {#if description}
      <span class="text-left">
        <strong class="block text-xl">{headline}</strong>
        <span>{description}</span>
      </span>
    {:else}
      <strong class="block text-left text-xl">{headline}</strong>
    {/if}
  </span>
</Button>
